export const ESG_REPORT_TYPES = [
  { value: 'BRSR', label: 'BRSR' },
  { value: 'GRI', label: 'GRI' },
  { value: 'SASB', label: 'SASB' },
  { value: 'TCFD', label: 'TCFD' },
  { value: 'ISSB', label: 'ISSB' },
  { value: 'CDP', label: 'CDP' },
  { value: 'IMPACT_REPORT', label: 'Impact Report' },
  { value: 'ANNUAL_REPORT', label: 'Annual Report' },
  { value: 'SUSTAINABILITY_REPORT', label: 'Sustainability Report' },
  { value: 'ESG_REPORT', label: 'ESG Report' },
  { value: 'INTEGRATED_REPORT', label: 'Integrated Report' },
  { value: 'PROGRESS_REPORT', label: 'Progress Report' },
  { value: 'COMBINED_MANAGEMENT_REPORT', label: 'Combined Management Report' },
  { value: 'OTHER', label: 'Other' },
];

export const REPORTING_PERIOD_TYPES = [
  { value: 'FINANCIAL', label: 'Financial Year' },
  { value: 'CALENDAR', label: 'Calendar Year' },
];

export const BUSINESS_TYPES = [
  { value: 'Brand', label: 'Brand' },
  { value: 'Manufacturer', label: 'Manufacturer' },
  { value: 'Integrated', label: 'Integrated' },
  { value: 'Retailer', label: 'Retailer' },
];

export const DEFAULT_REPORT_TYPE = 'SUSTAINABILITY_REPORT';
export const DEFAULT_REPORTING_YEAR = 2025; // FY 2025-26 when period type is FINANCIAL

export const CURRENT_YEAR = new Date().getFullYear();
export const REPORTING_YEAR_OPTIONS = Array.from({ length: 9 }, (_, index) => CURRENT_YEAR - index);

export function formatReportingYearLabel(year, reportingPeriodType) {
  if (reportingPeriodType === 'FINANCIAL') {
    return `FY ${year}-${String(year + 1).slice(-2)}`;
  }
  return `CY ${year}`;
}

export function toSubmitYear(selectedYear, reportingPeriodType) {
  return reportingPeriodType === 'FINANCIAL' ? selectedYear + 1 : selectedYear;
}

export function labelForReportingPeriod(value) {
  if (!value) return '—';
  return REPORTING_PERIOD_TYPES.find((option) => option.value === value)?.label || value;
}

const BUSINESS_TYPE_BY_KEY = {
  BRAND: 'Brand',
  MANUFACTURER: 'Manufacturer',
  INTEGRATED: 'Integrated',
  RETAILER: 'Retailer',
};

export function normalizeBusinessType(raw) {
  if (!raw) return '';

  const str = String(raw).trim();

  if (BUSINESS_TYPES.some((option) => option.value === str)) {
    return str;
  }

  if (BUSINESS_TYPE_BY_KEY[str]) {
    return BUSINESS_TYPE_BY_KEY[str];
  }

  const upperKey = str.toUpperCase().replace(/\s+/g, '_');
  if (BUSINESS_TYPE_BY_KEY[upperKey]) {
    return BUSINESS_TYPE_BY_KEY[upperKey];
  }

  const caseInsensitiveMatch = BUSINESS_TYPES.find(
    (option) => option.value.toLowerCase() === str.toLowerCase(),
  );

  return caseInsensitiveMatch?.value ?? str;
}

export function labelForBusinessType(value) {
  const normalized = normalizeBusinessType(value);
  if (!normalized) return '—';
  return BUSINESS_TYPES.find((option) => option.value === normalized)?.label ?? normalized;
}

export function normalizeReportType(raw) {
  if (!raw) return '';

  const str = String(raw).trim();
  const byValue = ESG_REPORT_TYPES.find((option) => option.value === str);
  if (byValue) return byValue.value;

  const byLabel = ESG_REPORT_TYPES.find(
    (option) => option.label.toLowerCase() === str.toLowerCase(),
  );
  return byLabel?.value ?? str;
}

export function labelForReportType(value) {
  const normalized = normalizeReportType(value);
  if (!normalized) return '—';
  return ESG_REPORT_TYPES.find((option) => option.value === normalized)?.label ?? normalized;
}
